document.addEventListener('click', function (event) {
  const option = event.target.closest('[data-quantity]');
  if (!option) return;
  const root = option.closest('[data-product-root]');
  if (!root) return;
  root.querySelectorAll('[data-quantity]').forEach(function (item) {
    item.classList.remove('is-selected');
    item.setAttribute('aria-pressed', 'false');
  });
  option.classList.add('is-selected');
  option.setAttribute('aria-pressed', 'true');
  const input = root.querySelector('[data-quantity-input]');
  const total = root.querySelector('[data-bundle-total]');
  if (input) input.value = option.dataset.quantity;
  if (total) total.textContent = '$' + option.dataset.total;
});

function initReviewSliders(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-review-slider]').forEach(function (track) {
    if (track.dataset.autoplayReady === 'true') return;
    track.dataset.autoplayReady = 'true';

    const cards = Array.from(track.querySelectorAll('.sample-review-card'));
    if (cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let activeIndex = 0;
    let timer;
    const start = function () {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        activeIndex = (activeIndex + 1) % cards.length;
        track.scrollTo({ left: cards[activeIndex].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }, 3000);
    };
    const stop = function () { window.clearInterval(timer); };

    track.addEventListener('pointerenter', stop);
    track.addEventListener('pointerleave', start);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    start();
  });
}

document.addEventListener('DOMContentLoaded', function () { initReviewSliders(document); });
document.addEventListener('shopify:section:load', function (event) { initReviewSliders(event.target); });

function initProductGalleries(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-product-gallery]').forEach(function (galleryRoot) {
    if (galleryRoot.dataset.galleryReady === 'true') return;
    galleryRoot.dataset.galleryReady = 'true';

    const track = galleryRoot.querySelector('.product-gallery');
    const slides = Array.from(galleryRoot.querySelectorAll('[data-gallery-slide]'));
    const dots = galleryRoot.querySelector('.product-gallery-dots');
    const previous = galleryRoot.querySelector('[data-gallery-previous]');
    const next = galleryRoot.querySelector('[data-gallery-next]');
    if (!track || !dots || slides.length < 2) return;

    const getCurrentIndex = function () {
      return slides.reduce(function (closest, slide, index) {
        const distance = Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft);
        return distance < closest.distance ? { index: index, distance: distance } : closest;
      }, { index: 0, distance: Infinity }).index;
    };
    const showSlide = function (index) {
      const normalizedIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[normalizedIndex].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    };

    if (previous) previous.addEventListener('click', function () { showSlide(getCurrentIndex() - 1); });
    if (next) next.addEventListener('click', function () { showSlide(getCurrentIndex() + 1); });

    const buttons = slides.map(function (slide, index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-gallery-dot' + (index === 0 ? ' is-active' : '');
      button.setAttribute('aria-label', 'Show product image ' + (index + 1));
      button.addEventListener('click', function () { showSlide(index); });
      dots.appendChild(button);
      return button;
    });

    let ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        const current = getCurrentIndex();
        buttons.forEach(function (button, index) { button.classList.toggle('is-active', index === current); });
        ticking = false;
      });
    }, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', function () { initProductGalleries(document); });
document.addEventListener('shopify:section:load', function (event) { initProductGalleries(event.target); });

document.addEventListener('submit', async function (event) {
  const form = event.target.closest('.product-form');
  if (!form) return;

  event.preventDefault();

  const variantInput = form.querySelector('[name="id"]');
  const quantityInput = form.querySelector('[data-quantity-input]');
  const submitButton = form.querySelector('[type="submit"]');
  const variantId = variantInput && variantInput.value;
  const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

  if (!variantId) return;
  if (submitButton) submitButton.disabled = true;

  try {
    const cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!cartResponse.ok) throw new Error('Unable to read cart');

    const cart = await cartResponse.json();
    const existingItem = cart.items.find(function (item) {
      return String(item.variant_id) === String(variantId);
    });

    const response = existingItem
      ? await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: existingItem.key, quantity: quantity })
        })
      : await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
        });

    if (!response.ok) throw new Error('Unable to update cart');
    window.location.assign('/cart');
  } catch (error) {
    if (submitButton) submitButton.disabled = false;
    window.alert('We could not update your bag. Please try again.');
  }
});

